<!-- [hidden]="!showComponent"-->
<div id="flex-container">
  <div class="div-element" id="tco-container">
    <canvas id="tco-chart"></canvas>
  </div>

  <!-- *ngIf="showComponent" -->
  <div class="div-element" id="results-container">
    <ul>
      <li>
        <h2>TCO Diesel</h2>
        <p>{{this.dieselTco.getTCO()}}</p>
      </li>
      <li>
        <h2>TCO Eléctrico</h2>
        <p>{{this.electricTco.getTCO()}}</p>
      </li>
      <li>
        <h2>TCO Hidrógeno</h2>
        <p>{{this.hydrogenTco.getTCO()}}</p>
      </li>
    </ul>
<!--    <h2>TCO Diesel</h2>-->
<!--    <p>{{this.dieselTco.getTCO()}}</p>-->
<!--    <h2>TCO Eléctico</h2>-->
<!--    <p>{{this.electricTco.getTCO()}}</p>-->
<!--    <h2>TCO Hidrógeno</h2>-->
<!--    <p>{{this.hydrogenTco.getTCO()}}</p>-->
  </div>
</div>
<!--<div id="clear"></div>-->
